module.exports = __webpack_public_path__ + "static/media/carrom.6856d91c.png";